import { Paper, Typography } from '@mui/material';
import clsx from 'clsx';
import { Property } from 'csstype';
import { ReactNode } from 'react';

import styles from './ContainedTable.module.scss';


export interface ContainedTableProps {
    children: ReactNode;
    className?: string;
    tableClassName?: string;
    headers: Array<string | { value: string, align?: Property.TextAlign }>;
}

export function ContainedTable({
    children, headers, className, tableClassName
}: ContainedTableProps) {
    return (
        <Paper
            variant="outlined"
            className={clsx(styles.root, className)}
        >
            <table className={clsx(styles.table, tableClassName)}>
                <thead>
                    <tr>
                        {headers.map((header) => (
                            <Typography
                                key={header.toString()}
                                component="th"
                                variant="caption"
                                color="textSecondary"
                                style={typeof header === 'object' ? { textAlign: header.align } : undefined}
                            >
                                {typeof header === 'string' ? header : header.value}
                            </Typography>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {children}
                </tbody>
            </table>
        </Paper>
    );
}
